exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".topBox[data-v-36cad140]{position:absolute;width:100%;left:0;top:56vw;overflow:hidden}.scroll[data-v-36cad140]{height:24px;background:rgba(220,29,0,.8);line-height:24px;display:flex;color:#fcefa9;overflow:hidden}.scroll .news[data-v-36cad140]{margin:0 5px;color:#f7c85d;display:flex}.scroll .news img[data-v-36cad140]{width:16px;height:16px;margin-top:4px;margin-right:4px}.scrollList[data-v-36cad140]{flex:1;position:absolute;overflow:hidden;height:24px;top:0;left:94px;width:100%}.scrollList ul[data-v-36cad140]{position:absolute;transition:top .5s;width:100%;height:34px}.scrollList ul span[data-v-36cad140]{color:#fcefa9}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"id":"data-v-36cad140","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Modular/Top.vue
// module id = 283
// module chunks = 0